import React, { useEffect, useState } from 'react';
import {  message } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/global.css';
import regionWiseContentManagementApi from '../services/regionWiseContentManagementApi';
import tripManagementApi from '../services/tripManagementApi';
import PopupComponent from '../utils/PopupComponent';
import DataImportConfirmationSelector from '../components/custom/DataImportConfirmation';
import cityApi from '../services/cityApi';
import { importStrategies, ImportOption } from '../services/importHandler';
import { SelectionValueMap,SelectionOption } from '../services/overrideAppendMap';
import ExportEnforcePopup from '../components/custom/ExportEnforcePopup';
import { 
    CityParams,
    POIParams, 
    TripPOIParams,
    CityExportParams, 
    POIExportParams, 
    TripPOIExportParams,
    ImportValidationErrorResponse,
    ErrorReportParams
} from '../services/importExportTypes';
import importExportApi from '../services/importExportApi';
import { exportXlsxFromResponse} from '../utils/downloadDataUsingBlobHelper';
import ImportValidationMessagePopup from '../components/custom/ImportValidationMessagePopup';
import { EntityTypeMap,EntityTypeOption } from '../services/importValidationEntityMap';
import Spinner from '../components/custom/Spinner';
import * as XLSX from 'xlsx';

type OptionType = 'override' | 'append';

const ImportPage : React.FC = () => {

  const navigate = useNavigate();
  const [regionItems, setRegionItems] = useState<RegionResponse[]>([]);
  const [tripItems, setTripItems] = useState<TripResponse[]>([]);
  const [cityItems, setCityItems] = useState<CityResponse[]>([]);
  const [selectedRegionId, setSelectedRegionId] = useState<string>('-999');
  const [selectedRegionText, setSelectedRegionText] = useState<string>('');
  const [selectedCityId, setSelectedCityId] = useState<string>('-999');
  const [selectedCityText, setSelectedCityText] = useState<string>('');
  const [isDisabledCity, setIsDisabledCity] = useState<boolean>(true);
  const [selectedDirectionId, setSelectedDirectionId] = useState<string>('-999');
  const [selectedTripId, setSelectedTripId] = useState<string>('-999');
  const [selectedTripText, setSelectedTripText] = useState<string>('');
  const [isDisabledTrip, setIsDisabledTrip] = useState<boolean>(true);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectionOverrideAppend, setSelectionOverrideAppend] = useState<OptionType | null>(null);
  const [isLoadingOptionsRegion, setIsLoadingOptionsRegion] = useState<boolean>(true);
  const [isLoadingOptionsCity, setIsLoadingOptionsCity] = useState<boolean>(false);
  const [isLoadingOptionsTrip, setIsLoadingOptionsTrip] = useState<boolean>(false);

  const [showTripPOIDiv, setShowTripPOIDiv] = useState(false);
  const [showRegionTags, setRegionTags] = useState(true);
  const [showCityTags, setCityTags] = useState(false);
  const [importFileContent, setImportFileContent] = useState<File | null>(null);

  const [messageApi, contextHolder] = message.useMessage();
  const [errorMessageRegion, setErrorMessageRegion] = useState<string>('');
  const [errorMessageCity, setErrorMessageCity] = useState<string>('');
  const [errorMessageDirection, setErrorMessageDirection] = useState<string>('');
  const [errorMessageTrip, setErrorMessageTrip] = useState<string>('');
  const [showPopupEnforcement, setshowPopupEnforcement] = useState<boolean>(false);
  const [enforceDownload, setEnforceDownload] = useState<boolean>(false);
  const [isEncfornceExportState, setIsEncfornceExportState] = useState(false);
  const [isImportConfirm, setIsImportConfirm] = useState<boolean>(false);
  //VALIDATION MSG POPUP
  const [importValidationErrors, setImportValidationErrors] = useState<string[]>([]);
  const [showValidationErrorPopup, setShowValidationErrorPopup] = useState(false);
  const [errorReportParams, setErrorReportParams] = useState<ErrorReportParams>();
  const [showDownloadErrorReportDiv, setShowDownloadErrorReportDiv] = useState<boolean>(false);
  
  const [isDisabledUploadCSV, setIsDisabledUploadCSV] = useState(true);
  const [isDownloadingErrorReport, setIsDownloadingErrorReport] = useState(false);

  const openPopup = () => setShowPopup(true);

  const closePopup = () => {
    setSelectionOverrideAppend(null);
    setShowPopup(false);
  };
  
  const openWarningExportPopup = () => setshowPopupEnforcement(true);
  const closeWarningExportPopup = () => {
    setshowPopupEnforcement(false);
  };

  const handleEnforceExport = async () => {

    let  downloadedFileName ='';
    try {
      setIsEncfornceExportState(true);
      switch (selectedGroupButton) {
        case 'city':
          const cityParams: CityExportParams = {
            regionID: selectedRegionId,
            regionName : selectedRegionText,
          };
          const importResponseCity = await importExportApi.exportCity(cityParams);
          downloadedFileName = exportXlsxFromResponse(importResponseCity, selectedGroupButton);
          break;
        case 'POI':
          const poiParams: POIExportParams = {
            cityID: selectedCityId,
            cityName: selectedCityText,
          };
          const importResponsePOI = await importExportApi.exportPOI(poiParams);
          downloadedFileName = exportXlsxFromResponse(importResponsePOI, selectedGroupButton);
          break;

        case 'TripPOI':
          const tripPOIParams: TripPOIExportParams = {
            tripManagementID: selectedTripId,
            tripName: selectedTripText,
          };
         const importResponseTripPOI = await importExportApi.exportTripPOI(tripPOIParams);
         downloadedFileName = exportXlsxFromResponse(importResponseTripPOI, selectedGroupButton);
          break;
        default:
          throw new Error('Unsupported option selected');
      }

      // if (!importResponse.ok) 
      //   throw new Error('API error');
      messageApi.success(`${downloadedFileName} Downloaded successfully`);
      //setShowDownloadOptions(false);
      setEnforceDownload(true);
      setshowPopupEnforcement(false);
    } catch (err) {
      messageApi.error((err as Error).message);
    }
    finally {
        setIsEncfornceExportState(false);
        setshowPopupEnforcement(false);
    }
  };

  const handleWarningExportCancel = () => {
    setshowPopupEnforcement(false);
    cancelFileUploadSelection();
  };

  const handleBackClick = async () => {
    navigate('/data-imp-exp-home');
  };

  const [selectedGroupButton, setSelectedGroupButton] = useState<string>('city');

   useEffect(() => {
    const fetchRegion = async () => {
      try {
        setIsLoadingOptionsRegion(true);
        const regionsResponse = await regionWiseContentManagementApi.getRegionWiseContentManagement();
        if (Array.isArray(regionsResponse.data)) {
          setRegionItems(regionsResponse.data);
        }
      } catch (err) {
        console.error('Failed to load region:', err);
      }
      finally {
        setIsLoadingOptionsRegion(false);
      }
    };

    fetchRegion();
  }, []);

  const handleRegionChangeAction = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;
    
    setSelectedRegionId(value);
    setSelectedRegionText(selectedText);
    setShowDownloadErrorReportDiv(false);
    setEnforceDownload(false);
    setshowPopupEnforcement(false);    

    if(value === '-999'){
      setSelectedCityId(value);
      setIsDisabledCity(true);
      setIsDisabledUploadCSV(true);
      return;    
    }
    else
      setErrorMessageRegion('');

    if (selectedGroupButton == 'POI') {
      try {
        setIsLoadingOptionsCity(true);
        const city = await cityApi.getCitiesByRegionId(value);
        if (Array.isArray(city.cityDataResponses)) {
          setCityItems(city.cityDataResponses);
        }
        setIsDisabledCity(false);
      }
      catch (error) {
        console.error('Failed to fetch city:', error);
      } finally {
        setIsLoadingOptionsCity(false);
      }
    }
    else
      setIsDisabledUploadCSV(false);
  };

  const handleCityChangeAction = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;
    setSelectedCityId(value);
    setSelectedCityText(selectedText);
    setShowDownloadErrorReportDiv(false);
    setEnforceDownload(false);
    setshowPopupEnforcement(false);

    if(value != '-999'){
      setErrorMessageCity('');
      setIsDisabledUploadCSV(false);
    }
    else{
      setIsDisabledUploadCSV(true);
    }

  };

  const directionChangeAction = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const directionValue = e.target.value;
    setSelectedDirectionId(directionValue);
    setShowDownloadErrorReportDiv(false);
    setEnforceDownload(false);
    setshowPopupEnforcement(false);

     if(directionValue === '-999'){
      setSelectedTripId(directionValue);
      setIsDisabledTrip(true);
      return;    
    }
    else{
      setErrorMessageDirection('');
    }

    try {
      setIsLoadingOptionsTrip(true);
      const trip = await tripManagementApi.getTripManagementByDirectionId(directionValue);

      if (Array.isArray(trip)) {
        setTripItems(trip);
      }
      setIsDisabledTrip(false);
    } catch (error) {
      console.error('Failed to fetch trip:', error);
    } finally {
      setIsLoadingOptionsTrip(false);
    }
  };

  const handleTripChangeAction = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;

    setSelectedTripId(value);
    setSelectedTripText(selectedText);
    setShowDownloadErrorReportDiv(false);
    setEnforceDownload(false);
    setshowPopupEnforcement(false);
    
    if(value != '-999'){
        setErrorMessageTrip('');
        setIsDisabledUploadCSV(false);
    }
    else{
      setIsDisabledUploadCSV(false);
    }
  };

 // Handle file selection & validation
  const handleFileUploadAction = (e: React.ChangeEvent<HTMLInputElement>) => {
    const imporFile = e.target.files?.[0];
    if (!imporFile) return;

    const fileName = imporFile.name.toLowerCase();
    const fileType = imporFile.type;

  // const isXLSX = fileName.endsWith('.xlsx') || 
  //     fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  const isExcel =
    fileName.endsWith('.xlsx') ||
    fileName.endsWith('.xls') ||
    fileType === 'application/vnd.ms-excel' ||
    fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (isExcel) {
      setSelectedFile(imporFile);
      readUploadedXlsxContent(imporFile);
      if (!enforceDownload) {
        setshowPopupEnforcement(true);
      }
    }
    // if (isCSV) {
    //   //To display cancel and upload button.
    //   setSelectedFile(imporFile);
    //   readUploadedCsvContent(imporFile);
    //   setshowPopupEnforcement(true);
    // }
    else
    {
      setSelectedFile(null);
      setImportFileContent(null);
      setshowPopupEnforcement(false);
      //setUploadStatus('');
      messageApi.error('Please select a valid XLS or XLSX file.');
      e.target.value = '';
      return;
    }
  };

  // const readUploadedXlsxContent = (file: File) => {
  //   setImportFileContent(file);

  //   const reader = new FileReader();

  //   reader.onload = (e) => {
  //     try {
  //       const data = new Uint8Array(e.target!.result as ArrayBuffer);
  //       const workbook = XLSX.read(data, { type: 'array' });

  //       // Validation 1: No sheets in the workbook
  //       if (!workbook.SheetNames.length) {
  //         messageApi.error("No sheets found in Excel file.");
  //         setImportFileContent(null);
  //         return;
  //       }

  //       // Validation 2: Count filled (non-empty) worksheets
  //       const filledSheetCount = workbook.SheetNames.reduce((count, sheetName) => {
  //         const sheet = workbook.Sheets[sheetName];
  //         const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  //         return json.length > 0 ? count + 1 : count;
  //       }, 0);

  //       if (filledSheetCount === 0) {
  //         messageApi.error("Excel file is empty.");
  //         setImportFileContent(null);
  //         return;
  //       }

  //       if (filledSheetCount > 1) {
  //         messageApi.error("Excel file must have only one filled sheet.");
  //         setImportFileContent(null);
  //         return;
  //       }

  //       // Proceed with the first filled worksheet
  //       const firstSheetName = workbook.SheetNames.find(sheetName => {
  //         const sheet = workbook.Sheets[sheetName];
  //         const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  //         return json.length > 0;
  //       });

  //       const worksheet = workbook.Sheets[firstSheetName!];
  //       const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  //       console.log("Valid XLSX content:", jsonData);
  //       // Use jsonData as needed (set to state, validate headers, etc.)

  //     } catch (err) {
  //       console.error("XLSX read error:", err);
  //       messageApi.error('Failed to read XLSX file');
  //       setImportFileContent(null);
  //     }
  //   };

  //   reader.onerror = () => {
  //     messageApi.error('Error reading XLSX file');
  //     setImportFileContent(null);
  //     reader.abort();
  //   };

  //   reader.readAsArrayBuffer(file);
  // };

  const readUploadedXlsxContent = (file: File) => {
    setImportFileContent(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });

        // Validation 1: No sheets in the workbook
        if (!workbook.SheetNames.length) {
          messageApi.error("No sheets found in Excel file.");
          setImportFileContent(null);
          return;
        }

        // Validation 2: Count filled (non-empty) worksheets
        const filledSheetCount = workbook.SheetNames.reduce((count, sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          return json.length > 0 ? count + 1 : count;
        }, 0);

        if (filledSheetCount === 0) {
          messageApi.error("Excel file is empty.");
          setImportFileContent(null);
          return;
        }

        if (filledSheetCount > 1) {
          messageApi.error("Excel file must have only one filled sheet.");
          setImportFileContent(null);
          return;
        }

        // Proceed with the first filled worksheet
        const firstSheetName = workbook.SheetNames.find(sheetName => {
          const sheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          return json.length > 0;
        });

        const worksheet = workbook.Sheets[firstSheetName!];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        console.log("Valid Excel content:", jsonData);
        // Use jsonData as needed (set to state, validate headers, etc.)

      } catch (err) {
        console.error("Excel read error:", err);
        messageApi.error('Failed to read Excel file');
        setImportFileContent(null);
      }
    };

    reader.onerror = () => {
      messageApi.error('Error reading Excel file');
      setImportFileContent(null);
      reader.abort();
    };
    reader.readAsArrayBuffer(file);
  };

  // Cancel selected files
  const cancelFileUploadSelection = () => {
    setSelectedFile(null);
    const input = document.getElementById('fileInput') as HTMLInputElement | null;
    if (input) input.value = ''; // reset input
  };

  const dataImportValidation = () => {
      let validationFlag: boolean;
      validationFlag = true;

      switch (selectedGroupButton) {
      case 'city':
        if(selectedRegionId == "-999")
          {
            validationFlag = false;
            setErrorMessageRegion('Please select a region');
          }
        break;
      case 'POI':
        if(selectedRegionId == "-999"){
          validationFlag = false;
          setErrorMessageRegion('Please select a region');
        }
        if(selectedCityId == "-999"){
          validationFlag = false;
          setErrorMessageCity('Please select a city');
        }
        break;
      case 'TripPOI':
        if(selectedDirectionId == "-999"){
          validationFlag = false;
          setErrorMessageDirection('Please select a direction');
        }
        if(selectedTripId == "-999"){
          validationFlag = false;
          setErrorMessageTrip('Please select a trip');
        }
        break;
      }
      return validationFlag;
  };

  const importChoiceSelection = (choice:string) => {
    switch (choice) {
      case 'city':
        setShowTripPOIDiv(false);
        setCityTags(false);
        setRegionTags(true);
        break;
      case 'POI':
        setShowTripPOIDiv(false);
        setCityTags(true);
        setRegionTags(true);
        break;
      case 'TripPOI':
        setShowTripPOIDiv(true);
        setCityTags(false);
        setRegionTags(false);
        break;
      }
  };
    
  const handleDownloadErrorReport = async () => {

    try {

    setIsDownloadingErrorReport(true);
    let downloadedErrorReportFileName = '';
    const errorReportResponse = await importExportApi.
                exportImportErrorReport(errorReportParams);

    downloadedErrorReportFileName = exportXlsxFromResponse(errorReportResponse,selectedGroupButton);
    messageApi.success(`${downloadedErrorReportFileName} Error Report Downloaded successfully`);
    }
    catch (err) {
        console.error('Failed to download the error report:', err);
        messageApi.error('Failed to download the error report');
      }
      finally {
        setIsDownloadingErrorReport(false);
      }
  };

  const handleDataImportConfirm = async () => {
    if (!selectionOverrideAppend) {
      messageApi.error('Please select an option!');
      return;
    }

    if (!importFileContent) {
      messageApi.error('Please select an option!');
      return;
    }

    let entityId: string | undefined;
    let importValidationEntity: number | undefined;
    try {
       
      setIsImportConfirm(true);
      switch (selectedGroupButton) {
        case 'city':
          const cityParams: CityParams = {
            RegionID: selectedRegionId,
            RegionName : selectedRegionText,
            CityFile : importFileContent,
            ImportStatus : SelectionValueMap[selectionOverrideAppend],
          };
          entityId = selectedRegionId;
          importValidationEntity = EntityTypeMap[selectedGroupButton];
          const importResponseCity = await importStrategies.City(cityParams);
          break;
        case 'POI':
          const poiParams: POIParams = {
            CityID: selectedCityId,
            CityName: selectedCityText,
            RegionPOIFile: importFileContent,
            ImportStatus: SelectionValueMap[selectionOverrideAppend],
          };
          entityId = selectedCityId;
          importValidationEntity = EntityTypeMap[selectedGroupButton];
          const importResponsePOI = await importStrategies.POI(poiParams);
          break;

        case 'TripPOI':
          const tripPOIParams: TripPOIParams = {
            TripManagementID: selectedTripId,
            TripName: selectedTripText,
            TripPOIFile: importFileContent,
            ImportStatus:SelectionValueMap[selectionOverrideAppend],
          };
          entityId = selectedTripId;
          importValidationEntity = EntityTypeMap[selectedGroupButton];
          const importResponseTripPOI = await importStrategies.TripPOI(tripPOIParams);
          break;

        default:
          throw new Error('Unsupported option selected');
      }

      // if (!importResponse.ok) 
      //   throw new Error('API error');
      messageApi.success(`File imported successfully`);

      setTimeout(() => {
         handleBackClick();
      }, 1200);
      
    } catch (err: any) {
      ///Validation popup to display
      
      if (err.response?.status === 400) {
          messageApi.error('File validation failed. Please check your data.');

        const errorData: ImportValidationErrorResponse = err.response.data;
        setImportValidationErrors(errorData.errors);
        setShowValidationErrorPopup(true);
        setShowDownloadErrorReportDiv(true);
        cancelFileUploadSelection();
        setErrorReportParams({
          id : entityId ?? '',
          importValidationEntity : importValidationEntity ?? 0
        });
      }
      else{
         messageApi.error((err as Error).message);
      }
    }
    finally{
      setIsImportConfirm(false);
    }
    closePopup();
      
  };

  const handleCity = () => {
    setSelectedGroupButton('city');
    importChoiceSelection('city');
    resetInitialState();
  };

  const handlePOI = () => {
    setSelectedGroupButton('POI');
    importChoiceSelection('POI');
    resetInitialState();
  };

  const handleTripPOI = () => {
    setSelectedGroupButton('TripPOI');
    importChoiceSelection('TripPOI');
    resetInitialState();
  };

  const resetInitialState = () => {
    
    setSelectedRegionId('-999');
    setSelectedCityId('-999');
    setSelectedDirectionId('-999');
    setSelectedTripId('-999');
    setIsDisabledCity(true);
    setIsDisabledTrip(true);
    setIsDisabledUploadCSV(true);
    cancelFileUploadSelection();
    setShowDownloadErrorReportDiv(false);
    setEnforceDownload(false);
    setshowPopupEnforcement(false);
  }

  //Obsolete function
  const readUploadedCsvContent = (file: File) => {
    setImportFileContent(file);

    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const text = event.target?.result as string;
    };

    reader.onerror = (error) => {
    messageApi.error('Please check csv file content');
    setImportFileContent(null); 
    reader.abort();
  };
  reader.readAsText(file);
  };

  return (
    <>
      {contextHolder} {/* Always rendered at top */}

    <div style={styles.container}>

      {/* Left Side */}
      <div style={styles.leftPanel}>
        
        {/* Back Arrow */}
        <div style={styles.backArrow} onClick={handleBackClick}>
          ← Import
        </div>

        {/* Button Group */}
        <div style={styles.buttonGroup}>
            <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'city' ? styles.selected : {}),
        }}
        onClick={handleCity}
      >
        Import City
      </button>
      <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'POI' ? styles.selected : {}),
        }}
        onClick={handlePOI}
      >
        Import POI
      </button>
      <button
        style={{
          ...styles.button,
          ...(selectedGroupButton === 'TripPOI' ? styles.selected : {}),
        }}
        onClick={handleTripPOI}
      >
        Import Trip POI
      </button>
        </div>

        {/* Drop down group */}
        { (showRegionTags || showCityTags)  && (
        <div style={styles.gridGroup}>
        {/* Select Region */}
        <label id="region-label" htmlFor="region-select" 
          style=
          {{
            ...styles.label,
            display: showRegionTags ? 'block' : 'none',
          }}
         >Select Region
                {errorMessageRegion && (
                  <span
                    title={errorMessageRegion}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
         </label>
        <label id="city-label" htmlFor="city-select" 
          style=
          {{
            ...styles.label,
            display: showCityTags ? 'block' : 'none',
          }}
        >Select City
          {errorMessageCity && (
                  <span
                    title={errorMessageCity}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        </div>
        )}

        {/* Drop down group */}
        { (showRegionTags || showCityTags)  && (
        <div style={styles.gridGroup}>
          <select id="region-select" value={selectedRegionId} onChange={handleRegionChangeAction} 
          style=
          {{
            ...styles.select,
            display: showRegionTags ? 'block' : 'none',
          }}
          >
            {isLoadingOptionsRegion ? (
            <option>Loading...</option> // ✅ shown during loading
          ) : (
            <>
          <option value="-999">-- Select a region --</option>
            {regionItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.sectionName}
              </option>
          ))}
          </>
   )}
        </select>
          <select id="city-select" value={selectedCityId} onChange={handleCityChangeAction} 
          style=
          {{
            ...styles.select,
            display: showCityTags ? 'block' : 'none',
          }}
          disabled={isDisabledCity}>
            {isLoadingOptionsCity ? (
            <option>Loading...</option> // ✅ shown during loading
          ) : (
            <>
          <option value="-999">-- Select a city --</option>
            {cityItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.cityName}
              </option>
          ))}
          </>
          )}
        </select>
        </div>
        )}

         {/* Drop down group */}
         { showTripPOIDiv  && (
        <div style=
          {styles.gridGroup} >
        {/* Select Region //display: showTripPOIDiv ? 'block' : 'none',*/}
        <label htmlFor="direction-select" style={styles.label}>Select Direction
            {errorMessageDirection && (
                  <span
                    title={errorMessageDirection}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        <label id="trip-label" htmlFor="trip-select" style={styles.label}>Select Trip
          {errorMessageTrip && (
                  <span
                    title={errorMessageTrip}
                    style={{
                      color: 'red',
                      cursor: 'help',
                      fontWeight: 'bold',
                      fontSize: '24px',
                    }}
                  >
                     *
                  </span>
                )}
        </label>
        </div>
         )}
        {/* Drop down group */}
         { showTripPOIDiv  && (
        <div 
          style={styles.gridGroup}>
          <select id="direction-select" value={selectedDirectionId} onChange={directionChangeAction} style={styles.select}>
          <option value="-999">-- Select a direction --</option>
          <option value="0">Northwest</option>
          <option value="1">Southeast</option>
        </select>
          <select id="trip-select" value={selectedTripId} onChange={handleTripChangeAction} style={styles.select} disabled={isDisabledTrip}>
          {isLoadingOptionsTrip ? (
            <option>Loading...</option> // ✅ shown during loading
          ) : (
            <>
          <option value="">-- Select a trip --</option>
           {
              tripItems.map((item) => (
              <option key={item.id} value={item.id}>
                {item.tripName}
              </option>
          ))}
          </>
          )}
        </select>
        </div>
         )}

        <div style={styles.uploadArea}>
      {(selectedFile && enforceDownload) ? 
      (
        <div style={styles.importAreacontainer} >
          <div style={styles.importAreaLabelDiv}>
            Upload this {selectedFile.name} file ?
          </div>
          <div style={styles.importAreaCSVIconDiv}>
                <img
                  src="../images/Excelcon.png"
                  alt="Excel Icon"
                  style={styles.importAreaCSVIconImg}
                />
            </div>
          <div style={styles.buttonGroup}>
            <button
            style={styles.cancelButtonForUpload}
            onClick={(e) => {
              e.stopPropagation();
              cancelFileUploadSelection();
            }}
          >
		      Cancel
          </button>
          <button
            style={styles.uploadButton}
            onClick={(e) => {
              e.stopPropagation();
              
              if(dataImportValidation()){
                  openPopup();
              }
            }}
            >
            Upload
          </button>

          </div>
        </div>
      ) : (
        <>
          <p style={styles.uploadText}>Click on upload to import files</p>
          <button type="button" style={{ ...styles.uploadButton, marginTop: '25px'}} disabled={isDisabledUploadCSV}
            onClick={(e) => { e.stopPropagation(); document.getElementById('fileInput')?.click();
            }}
          >
            {/* You can insert SVG here if needed */}
            <span>Upload Excel</span>
          </button>
        </>
      )}

      <input
        id="fileInput"
        type="file"
        //accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={handleFileUploadAction}
        style={{ display: 'none' }}
      />

      { /*Download error report */}
      {showDownloadErrorReportDiv && (
      <div>
          <p style={styles.downloadText}>Click to download the error report</p>
          <button type="button" style={{ ...styles.downloadButtonForError, marginTop: '20px'}} 
            onClick={handleDownloadErrorReport}
          >
            {/* You can insert SVG here if needed */}
            {isDownloadingErrorReport && <Spinner />}
            {isDownloadingErrorReport ? 'Downloading...' : 'Download Error Report'}
          </button>
      </div>
        )}

    </div>
      </div>

      {/* Right Side */}
      {/* <div style={styles.rightPanel}>
        <img src="your-image.png" alt="Import Illustration" style={styles.image} />
        <p style={styles.description}>This panel shows import information and image description.</p>
      </div> */}
      { /* popup launch area */}
      {showPopup && (
        
        <PopupComponent
          title="Select the action to Overwrite or Append File"
          onClose={closePopup}
          onConfirm={handleDataImportConfirm}
          isConfirm={isImportConfirm}
        >
          <DataImportConfirmationSelector onSelect={setSelectionOverrideAppend} />
        </PopupComponent>
      )}

      {showPopupEnforcement  && (
        <ExportEnforcePopup
          // isOpen={showWarning}
          onCloseWarning={closeWarningExportPopup}
          onExport={handleEnforceExport}
          onCancel={handleWarningExportCancel}
          isExporting= {isEncfornceExportState}
       />
      )}

      {showValidationErrorPopup && (
        <ImportValidationMessagePopup
          onClose={() => setShowValidationErrorPopup(false)}
          title=":: Import Data Validation Error ::"
          errors={importValidationErrors}
          // errorParams={errorReportParams}
        />
      )}

    </div>
    </>
  );
};

export default ImportPage;


const baseGreen = '#3E767A';
const hoverGreen = '#5B9492';

const buttonBase = {
  padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: `2px solid ${baseGreen}`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    height: '86vh',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  leftPanel: {
    width: '80%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    maxHeight: '100vh',
  },
  backArrow: {
    fontSize: '32px',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#363636',
  },
  buttonGroup: {
    display: 'flex',
    gap: '20px',
    padding: '20px',
  },
  button: {
    ...buttonBase,
  },
  uploadButton: {
    ...buttonBase,
    backgroundColor: baseGreen,
    color: '#FFFFFF',
    width: '211px',
    height: '50px',
  },
  cancelButtonForUpload :{
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: `2px solid ${baseGreen}`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    width: '211px',
    height: '50px',
  },
  uploadText: {
    margin: 0,
    fontSize: '28px',
    color: '#555',
  },
  uploadbuttonText: {
     display: 'inline-block',
    lineHeight: '1.2',
    fontSize: '16px',
  },
  selected: {
    backgroundColor: baseGreen,
    color: '#FFFFFF',
  },
  labelGroup: {
    display: 'flex',
    flexDirection: 'row', 
    gap: '430px',           
    alignItems: 'center',  
    marginBottom: '8px',  
  },
  label: {
    color: '#3E767A', // final color
    textAlign: 'left',
    fontFamily: '"Merriweather Sans", sans-serif',
    fontWeight: 'bold',
    fontSize: '24px',
    letterSpacing: '0px',
    opacity: 1,
  },
  selectGroup : {
    display: 'flex',
    flexDirection: 'row', // default, optional
    gap: '223px',           // you can adjust spacing here (e.g., 8px, 12px, etc.)
    alignItems: 'center',  // optional: align labels vertically
    marginBottom: '12px',  // optional: spacing below group
  },
  select: {
    width: '54%',
    height: '40px',
    backgroundColor: '#F9F9FA',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.06)', // Converted from #0000000F
    borderRadius: '8px',
    border: '1px solid #ccc',
    padding: '0 12px',
    fontSize: '16px',
    outline: 'none',
  },
  uploadArea: {

    border: '2px dashed #3E767A',
    height: '50%',
    borderRadius: '10px',
    padding: '30px',
    textAlign: 'center' as const,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px', // Adds space between <p> and <button>
  },
  rightPanel: {
    width: '20%',
    backgroundColor: '#f4f4f4',
    padding: '24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    overflow: 'hidden',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '16px',
  },
  description: {
    fontSize: '14px',
    color: '#333',
  },
  tripPOILabelGroup: {
    display: 'flex',
    flexDirection: 'row', 
    gap: '430px',           
    alignItems: 'center',  
    marginBottom: '8px',  
  },
  tripPOISelectGroup : {
    display: 'flex',
    flexDirection: 'row', // default, optional
    gap: '223px',           // you can adjust spacing here (e.g., 8px, 12px, etc.)
    alignItems: 'center',  // optional: align labels vertically
    marginBottom: '12px',  // optional: spacing below group
  },
  gridGroup: {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
  alignItems: 'center',
  marginBottom: '8px',
},
importAreacontainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // centers all children horizontally
    gap: '16px',
    padding: '24px',
  },
   importAreaLabelDiv: {
    fontSize: '28px',
    fontWeight: 500,
    color: '#363636',
    textAlign: 'center',
  },
  importAreaCSVIconDiv: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '120px',
        margin: '0 auto',
  },
  importAreaCSVIconImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  downloadButtonForError : {
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: `2px solid ${baseGreen}`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    width: '211px',
    height: '50px',
  },
  downloadText: {
    margin: 0,
    fontSize: '20px',
    color: '#555',
  },
};

